export default "__VITE_ASSET__CKFVjLWW__$_?url__"